// Elenco delle news
var React = require('react');
import PropTypes from 'prop-types';
import {get} from './Storage';
var News = require('./News');

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'MGNewslistComponent';

class NewsList extends React.Component{
    //displayName: componentName,

    constructor(props) {
        super(props);
    }

    render() {
        var newsNodes = "";
        if (this.props.data.count > 0) {
            var newsNodes = this.props.data.news.map(function (news, i) {
                return (
                    <News key={news.id} news={news}/>
                )
            });
        }else{
            newsNodes = <div className="no-list">Non hai nuovi messaggi da leggere</div>;
        }
        return (
            <>
                {newsNodes}
            </>
        );
    }
};
NewsList.displayName = componentName;
// PropTypes validation
NewsList.propTypes = {
    data: PropTypes.object.isRequired
};

// default props
NewsList.defaultProps = {
    data: {}
};
export default NewsList;